@if (optimizationTileData$ | async; as optimizationTileData) {
  <div>
    <ziro-dashboard-tile
      [isLoading]="optimizationTileData.isLoading"
      [tile]="optimizationTileData.tileStatus"
    ></ziro-dashboard-tile>
  </div>
}
